export const hasIncompleteProfile = member => !member['first-name'] || !member['last-name'];

export const formatMemberBody = (id, attributes) => ({ data: { attributes } });

export const isSelfClaimedGift = gift => !!gift.claimerId && !!gift.memberId && gift.claimerId === gift.memberId;

export function getParameters(queryString) {
    const params = new URLSearchParams(queryString);
    const utmParameters = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of params.entries()) {
        utmParameters[key] = value;
    }

    return utmParameters;
}

export function filterUTMParams(url, prefix = '&') {
    const params = new URLSearchParams(url);

    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'redeemCode', 'orderQuantity', 'orderId', 'shopifyOrderId'];
    const filteredParams = new URLSearchParams();

    for (const [key, value] of params) {
        if (utmParams.includes(key)) {
            filteredParams.append(key, value);
        }
    }

    return filteredParams.toString() ? `${prefix}${filteredParams.toString()}` : '';
}

export function updateUtmMedium(queryString) {
    const parts = queryString.split('&');

    const updated = parts.map(pair => {
        const [key, value] = pair.split('=');

        if (key === 'utm_medium') {
            return `${key}=hero-button`;
        }
        return pair;
    });

    return updated.join('&');
}

export default hasIncompleteProfile;
